import buildClassName from '../../../util/buildClassName';

import styles from './TelegrafLogo.module.scss';

import logoPath from '../../../assets/telegraf-logo.png';

type OwnProps = {
  className?: string;
  withWordmark?: boolean;
};

// Telegraf's own mark, with the name beside it when asked
const TelegrafLogo = ({ className, withWordmark }: OwnProps) => {
  return (
    <div className={buildClassName(styles.root, className)}>
      <img className={styles.mark} src={logoPath} alt="" draggable={false} />
      {withWordmark && <span className={styles.wordmark}>Telegraf</span>}
    </div>
  );
};

export default TelegrafLogo;
